import clsx from 'clsx';
import { OrderItemStatus } from 'constants/enums';
import { priceStyleHelper } from 'helpers/helperFunctions';
import i18n from 'i18n-js';
import React from 'react';
import { useStyles } from '../styles';
import { theme } from 'config/theme';

interface PriceTextProps {
    price: string | number;
    isPaid?: boolean;
    itemStatus?: OrderItemStatus;
    isDisabled?: boolean;
    isStorno?: boolean;
}

export function PriceText({
    price,
    isPaid = false,
    itemStatus,
    isDisabled = false,
    isStorno = false,
}: PriceTextProps) {
    const classes = useStyles();

    return (
        <div>
            <div
                className={clsx(classes.orderItemCardPrice, {
                    [classes.orderItemCardPriceReady]: itemStatus === OrderItemStatus.Ready,
                    [classes.disabledOrderItemAmount]: isDisabled,
                })}
            >
                <span style={{ paddingBottom: 2 }}>{i18n.t('common.currencies.chf')}</span>
                <span className={classes.itemPrice}>{priceStyleHelper(price, true)}</span>
            </div>
            {isPaid && !isStorno && <div className={classes.paidText}>/ PAID</div>}
            {isStorno && (
                <div className={classes.paidText} style={{ color: theme.palette.error.main }}>
                    / STORNO
                </div>
            )}
        </div>
    );
}
